import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgBiColumns({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 16 16"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<rect width={16} height={16} stroke={finalColor} />
			<path
				d="M13.5568 1.00067H2.37189C1.59563 1.00067 0.964355 1.69834 0.964355 2.55623V13.4451C0.964355 14.303 1.59563 15.0007 2.37189 15.0007H13.5568C14.3331 15.0007 14.9644 14.303 14.9644 13.4451V2.55545C14.9636 2.14321 14.8151 1.74811 14.5512 1.45669C14.2874 1.16527 13.9298 1.00129 13.5568 1.00067ZM5.18695 13.4451H2.37189V4.88878H5.18695V13.4451ZM9.40954 13.4451H6.59448V4.88878H9.40954V13.4451ZM10.8171 13.4451V4.88878H13.5568L13.5575 13.4451H10.8171Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgBiColumns;
